import React from 'react';
import PropTypes from 'prop-types';

import { formatBudgetScreenDateTime } from 'utils/helper';
import { getBudgetTemplateName, isAicpTemplateName } from 'utils/constants';
import BudgetTotalChip from './BudgetTotalChip';
import ContextualSuggestions from './ContextualSuggestions';

const BudgetFooter = ({
  contextualSuggestions,
  addedContextualSuggestions,
  swimlaneItems,
  scrollPosition,
  onBackClick,
  onForwardClick,
  onSuggestionClick,
  hasEditAccess,
  contextualSuggestionsRef,
  budgetData,
  budgetId,
  sessionDelta,
  currency,
  onResetSession,
  categoryId,
  isDetailView,
  suggestionScopeKey,
  categoryColumnFingerprint,
  hiddenSuggestionKeys,
}) => {
  const isAicpTemplate = isAicpTemplateName(getBudgetTemplateName(budgetData));

  return (
    <div className="budget-container__footer">
      <div className="budget-total-meta-container">
        {!isAicpTemplate && (
          <ContextualSuggestions
            contextualSuggestions={contextualSuggestions}
            addedContextualSuggestions={addedContextualSuggestions}
            swimlaneItems={swimlaneItems}
            scrollPosition={scrollPosition}
            onBackClick={onBackClick}
            onForwardClick={onForwardClick}
            onSuggestionClick={onSuggestionClick}
            hasEditAccess={hasEditAccess}
            contextualSuggestionsRef={contextualSuggestionsRef}
            budgetId={budgetId}
            categoryId={categoryId}
            isDetailView={isDetailView}
            suggestionScopeKey={suggestionScopeKey}
            categoryColumnFingerprint={categoryColumnFingerprint}
            hiddenSuggestionKeys={hiddenSuggestionKeys}
          />
        )}
        <div className="budget-total-meta">
          <span className="budget-modified">
            Last updated by{' '}
            <span className="budget-modified-by">
              {budgetData?.last_edited_by || budgetData?.created_by_name}
            </span>{' '}
            on{' '}
            {formatBudgetScreenDateTime(
              budgetData?.updated_on || budgetData?.created_on
            )}
          </span>
        </div>
      </div>
      <BudgetTotalChip
        budgetData={budgetData}
        currency={currency}
        sessionDelta={sessionDelta}
        onResetSession={onResetSession}
      />
    </div>
  );
};

BudgetFooter.propTypes = {
  contextualSuggestions: PropTypes.arrayOf(PropTypes.object),
  addedContextualSuggestions: PropTypes.object,
  swimlaneItems: PropTypes.arrayOf(PropTypes.object),
  scrollPosition: PropTypes.number.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onForwardClick: PropTypes.func.isRequired,
  onSuggestionClick: PropTypes.func.isRequired,
  hasEditAccess: PropTypes.func.isRequired,
  contextualSuggestionsRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  budgetData: PropTypes.object,
  budgetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sessionDelta: PropTypes.number,
  currency: PropTypes.string,
  onResetSession: PropTypes.func,
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isDetailView: PropTypes.bool,
  suggestionScopeKey: PropTypes.string,
  categoryColumnFingerprint: PropTypes.string,
  hiddenSuggestionKeys: PropTypes.object,
};

BudgetFooter.defaultProps = {
  contextualSuggestions: [],
  addedContextualSuggestions: {},
  swimlaneItems: [],
  contextualSuggestionsRef: null,
  budgetData: {},
  budgetId: null,
  sessionDelta: 0,
  currency: 'USD',
  onResetSession: undefined,
  categoryId: null,
  isDetailView: false,
  suggestionScopeKey: 'category:root',
  categoryColumnFingerprint: undefined,
  hiddenSuggestionKeys: {},
};

export default BudgetFooter;
